import Joi from "joi";
import { Coordinates, NewTrailerInput } from "../../../graphql/generated";
import customFieldSchema from "../../extensions/CustomFieldsForm/customFieldsSchema";
import documentSchema from "../../../utils/form/schemas/document.schema";

const trailerSchema = Joi.object<NewTrailerInput>({
  serialNumber: Joi.string().max(50).required().label("Asset Code"),
  licenseNumber: Joi.string().label("License Number").allow(null, ""),
  vin: Joi.string().label("VIN#").allow(null, ""),
  serial: Joi.string().label("Serial").allow(null, ""),
  type: Joi.string().label("Type").required(),
  mileage: Joi.number().label("Mileage").allow(null, ""),
  height: Joi.number().min(0).label("Height").allow(null, ""),
  width: Joi.number().min(0).label("Width").allow(null, ""),
  length: Joi.number().min(0).label("Length").allow(null, ""),
  maxWeight: Joi.number().min(1).label("Max Weight").allow(null, ""),
  minTemperature: Joi.number().label("Min Temperature").allow(null, ""),
  maxTemperature: Joi.number().label("Max Temperature").allow(null, ""),
  numberOfAxles: Joi.number().label("Number of axles").allow(null, ""),
  domicile: Joi.object<NewTrailerInput["domicile"]>({
    label: Joi.string().required().label("Address Label"),
    coordinates: Joi.object<Coordinates>({
      latitude: Joi.number().required(),
      longitude: Joi.number().required(),
    })
      .required()
      .label("Coordinates"),
    line1: Joi.string().allow("", null).label("Address Line 1"),
    line2: Joi.string().allow("", null).label("Address Line 2"),
    postalCode: Joi.string().allow("", null).label("Postal Code"),
    city: Joi.string().allow("", null).label("City"),
    state: Joi.string().allow("", null).label("State"),
    country: Joi.string().allow("", null).label("Country"),
    googlePlaceId: Joi.string().allow("", null).label("Google Place ID"),
  })
    .label("Physical Address")
    .allow(null),
  status: Joi.string().allow(null),
  hasMeteredPump: Joi.boolean().optional(),
  compartments: Joi.array()
    .items(
      Joi.object({
        identifier: Joi.string().allow("", null).label("Compartment ID"),
        capacity: Joi.number().min(0).label("Capacity"),
        unit: Joi.string().label("Unit"),
        minVolume: Joi.number().min(0).allow(null).label("Min Volume"),
        maxVolume: Joi.number().min(0).allow(null).label("Max Volume"),
        heavyOnly: Joi.boolean().allow(null),
        hasDoubleBulkheadAfter: Joi.boolean().allow(null),
      })
        .unknown(true)
        .custom((compartment, helpers) => {
          const { minVolume, maxVolume, capacity } = compartment;
          if (maxVolume != null && capacity != null && maxVolume > capacity) {
            return helpers.error("any.invalid", {
              message: "Max Volume cannot exceed Capacity",
            });
          }
          if (minVolume != null && maxVolume != null && minVolume > maxVolume) {
            return helpers.error("any.invalid", {
              message: "Max Volume cannot be less than Min Volume",
            });
          }
          return compartment;
        })
        .messages({
          "any.invalid": "{{#message}}",
        })
    )
    .allow(null),
  tags: Joi.array().items(Joi.string()).label("Tags").allow(null),
  customFields: Joi.array()
    .items(customFieldSchema)
    .label("Custom Fields")
    .allow(null),
  groupIds: Joi.array().items(Joi.string()).label("Group IDs").allow(null),
  documents: Joi.array().items(documentSchema).label("Documents").allow(null),
});

export default trailerSchema;
